import React from 'react';
import styles from './Text.module.scss';

interface Props {
  color?: 'default' | 'primary' | 'analogous' | 'white' | 'secondary' | 'gray';
  size?:
    | '72'
    | '52'
    | '42'
    | '32'
    | '28-18'
    | '28'
    | '24'
    | '22'
    | '20'
    | '18'
    | '16'
    | '14'
    | '12';
  className?: string;
  children: any;
}

const Text = (props: Props) => {
  const colorClass = `color__${props.color}` || 'color__default';
  const sizeClass = `size__${props.size}` || 'size__18';
  const propertyClass = props.className ? `${props.className}` : '';
  return (
    <p
      className={`${propertyClass} ${styles[colorClass]} ${styles[sizeClass]} ${styles.style}`}
    >
      {props.children}
    </p>
  );
};

export default Text;
